export const getColorChangingPigSvgIcon = (rotationAngle) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <style>
        @keyframes colorChange {
          0% { fill: #621ddb; }
          25% { fill: #b68dfc; }
          50% { fill: #621ddb; }
          75% { fill: #c56eff; }
          100% { fill: #621ddb; }
        }
        .color-changing {
          animation: colorChange 2s linear infinite;
        }
        .fixed-color {
          fill: #DDA0DD;
        }
        .stroke-black {
          stroke: black;
          stroke-width: 1;
        }
        .bounding-box {
          fill: none;
          stroke: red;
          stroke-width: 0.5;
        }
      </style>
      <!-- <rect x="0.25" y="0.25" width="47.5" height="47.5" class="bounding-box"/> -->
      <g transform="rotate(${rotationAngle}, 24, 24)">
        <!-- Top part of the PIG with rounded top -->
        <path d="M24 0 Q16 8, 14 8 H34 Q32 8, 24 0 Z" class="color-changing stroke-black"/>
        <path d="M14 8 A40 40 0 0 1 18 8 H30 A8 8 0 0 1 34 8 V16 H14 Z" class="color-changing stroke-black"/>
        
        <!-- Central rectangular body -->
        <rect x="18" y="16" width="12" height="16" class="fixed-color stroke-black"/>
        
        <!-- Bottom part of the PIG with flat bottom -->
        <rect x="14" y="32" width="20" height="8" class="color-changing stroke-black"/>
        <path d="M14 40 H34 L30 48 H18 Z" class="color-changing stroke-black"/>
        
        <!-- Top hole -->
        <circle cx="24" cy="4" r="2" class="stroke-black"/>
        
        <!-- Bottom connector -->
        <circle cx="24" cy="44" r="2" class="stroke-black"/>
        <rect x="22" y="44" width="4" height="4" fill="gray" class="stroke-black"/>
      </g>
    </svg>
  `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
